
<p-menubar>
  <ng-template pTemplate="start">
    <a routerLink="/" class="menubar-logo-link">
      <img src="/images/logo.jpg" alt="FaceBot logo" class="menubar-logo" />
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <p-menubar [model]="items()"></p-menubar>
  </ng-template>
</p-menubar>

<router-outlet />